import { motion } from "framer-motion";
import { ArrowUpRight, Pin, Play } from "lucide-react";
import { BRAND } from "../lib/brand";
import { item } from "../lib/motion";
import { PLATFORMS } from "./PlatformIcons";

// Large highlight card for the admin-pinned video on the homepage.
export default function PinnedVideo({ v }) {
  const p = PLATFORMS[v.platform] || PLATFORMS.facebook;
  return (
    <motion.a variants={item} href={v.url} target="_blank" rel="noreferrer" data-testid="pinned-video"
      className="glass-card overflow-hidden group grid md:grid-cols-5 mb-6">
      <div className="relative md:col-span-3 aspect-video md:aspect-auto md:min-h-[320px] overflow-hidden bg-black">
        <img src={v.thumbnail || BRAND.vortex} alt={v.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/40" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full glass flex items-center justify-center glow-blue group-hover:scale-110 transition-transform duration-500">
            <Play className="w-6 h-6 text-white ml-0.5" fill="white" />
          </div>
        </div>
      </div>
      <div className="md:col-span-2 p-8 flex flex-col justify-center">
        <span className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#4da6ff]"><Pin className="w-3.5 h-3.5" /> Featured</span>
        <h3 className="font-head text-2xl md:text-3xl font-light mt-4 leading-snug" data-testid="pinned-video-title">{v.title}</h3>
        <span className="mt-6 inline-flex items-center gap-2 text-sm text-zinc-400 group-hover:text-white transition-colors">
          <p.icon className="w-4 h-4" /> Watch on {p.label} <ArrowUpRight className="w-4 h-4" />
        </span>
      </div>
    </motion.a>
  );
}
